import React from 'react'
import PriceComparison from '@components/ui/PriceComparison'
import Title from '@components/ui/type/Title'
import Byline from '@components/ui/type/Byline'
import StarRatings from '@components/ui/StarRatings'
import { ProductCardProduct } from '../types'
import styles from './styles.module.scss'

type ProductHeaderProps = Pick<
  ProductCardProduct,
  'title' | 'byline' | 'price' | 'fullPrice'
> & {
  starRatings?: {
    total_review: number
    average_score: number
  }
}

const ProductHeader = ({
  title,
  byline,
  price,
  fullPrice,
  starRatings
}: ProductHeaderProps) => {
  const showStarRating = !!starRatings && starRatings.total_review > 0
  return (
    <div className={styles.ProductHeader__container}>
      <div className={styles.ProductHeader__title}>
        <Title
          type="h3"
          text={title}
          classes="title--default-size title--secondary title--left-mobile"
        />
      </div>
      <div className={styles.ProductHeader__byline}>
        <Byline
          text={byline}
          classes="byline--secondary byline--small-x1-size"
        />
      </div>
      <div className={styles.ProductHeader__row}>
        {!!price && (
          <div className={styles.ProductHeader__prices}>
            <PriceComparison
              price={price}
              fullPrice={fullPrice}
              size="medium-small-bold"
            />
          </div>
        )}
        {showStarRating && (
          <StarRatings
            averageScore={starRatings.average_score}
            totalReviews={starRatings.total_review}
          />
        )}
      </div>
    </div>
  )
}

export default ProductHeader
